import { request } from "@/utils/request";
import { BASE_URL } from "@/constants/config";

export const ANNEXIII_ENDPOINTS = {
  get_annexiii_by_campaign_member: (id_campaign, id_member) => `${BASE_URL}api/annexiii/${id_campaign}/${id_member}`,
  create_annexiii: `${BASE_URL}api/annexiii/`,
  download_annexiii: (campaign_id, member_id) =>
    `${BASE_URL}api/annexiii/${campaign_id}/${member_id}/annexeiii/download`,

};

class AnnexIII {
  async getAnnexIIIByCampaignMember(id_campaign, id_member) {
    const { data } = await request({
      url: ANNEXIII_ENDPOINTS.get_annexiii_by_campaign_member(id_campaign, id_member),
    });
    return data;
  }

  async createAnnexiii(payload){
    return await request({
      url: ANNEXIII_ENDPOINTS.create_annexiii,
      method: "POST",
      body: payload,
    });
  }
}

export const AnnexIIIService = new AnnexIII();
